<button type="button" style="margin-left:10px;" class="button is-{{ButtonType}}" [ngStyle]="Color ? { 'background-color': '#' + Color } : null" (click)="DoAction()" [disabled]="Animate">
    <span class="icon-text">
        <span class="icon">
          <i class="fa fa-{{Icon}}" [ngClass]="{'fa-spinner fa-pulse' : Animate}"></i>
        </span>
        <span><ng-content></ng-content></span>
      </span>
</button>